import React, { useLayoutEffect, useState } from "react";
import { Alert, Button, Card, CardBody, CardText, CardTitle, Col, Row, UncontrolledTooltip } from "reactstrap";
import styles from "./style.module.scss";
import cx from "classnames";
import LoadingPlaceholder from "components/LoadingPlaceholder";
import { getPOBoxByUser } from "api/POBoxApi";
import { getUserData } from "utils/Session";
import { errorHandler } from "utils/Api";
import { poBoxLabelGenerator, poBoxSheinLabelGenerator } from "utils/Form";
import copyToClipboard from 'copy-to-clipboard';
import { showAlert } from "utils/Alert";
import { v4 as uuidv4 } from 'uuid';

const UserPOBoxDetails = (props) => {
  const { className } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [isPoBoxError, setIsPoBoxError] = useState(false);
  const [userPoBox, setUserPoBox] = useState({});
  const poBoxLabel = poBoxLabelGenerator(userPoBox);
  const poBoxSheinLabel = poBoxSheinLabelGenerator(userPoBox);
  const componentId = uuidv4();

  useLayoutEffect(() => {
    setIsLoading(true);
    fetchPOBox();
  }, []);

  const fetchPOBox = async () => {
    const userData = await getUserData();
    getPOBoxByUser(userData).then((r) => {
      setUserPoBox(r);
    }).catch((e) => {
      setIsPoBoxError(true);
      errorHandler(e)
    }).finally((e) => setIsLoading(false));
  }

  const copyText = (text) => {
    copyToClipboard(text);
    showAlert("success", "la informacion se copio correctamente");
  }

  return (
    <div className={className}>
      <Card className={cx(["h-100", className])}>
        < CardBody className={styles.cardBody} >
          <CardTitle tag="h5" className={styles.cardTitle} >
            <LoadingPlaceholder isLoading={isLoading}>
              Tu Direccion en Miami
            </LoadingPlaceholder>
          </CardTitle>
          <CardText className={styles.cardText} >
            {isPoBoxError && (
              <Alert
                color="danger"
              >
                No ha sido posible crear su casillero, comuniquese con servicio al cliente
              </Alert>
            )}
            {!isPoBoxError && (
              <LoadingPlaceholder className={styles.po_address} isLoading={isLoading}>
                {!isPoBoxError && (
                  <>
                    <Row>
                      <Col className="text-end" xs="6">
                        <b>Nombre (Casillero): </b>
                      </Col>
                      <Col xs="6">
                        <UncontrolledTooltip
                          placement="right"
                          target={`name-${componentId}`}
                        >
                          Copiar
                        </UncontrolledTooltip>
                        <Button className={styles.addressCopyButton} id={`name-${componentId}`} color="light" onClick={() => copyText(poBoxLabel)}>
                          {poBoxLabel}
                        </Button>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col className="text-end" xs="5">
                        <b>Nombre Shein: </b>
                      </Col>
                      <Col xs="7">
                        <UncontrolledTooltip
                          placement="right"
                          target={`name-${componentId}`}
                        >
                          Copiar
                        </UncontrolledTooltip>
                        <Button className={styles.addressCopyButton} id={`name-${componentId}`} color="light" onClick={() => copyText(poBoxSheinLabel)}>
                          {poBoxSheinLabel}
                        </Button>
                      </Col>
                    </Row> */}
                  </>
                )}
                <Row>
                  <Col className="text-end" xs="6"><b>Address 1: </b> </Col>
                  <Col xs="6">
                    <UncontrolledTooltip
                      placement="right"
                      target={`address-${componentId}`}
                    >
                      Copiar
                    </UncontrolledTooltip>
                    <Button className={styles.addressCopyButton} id={`address-${componentId}`} color="light" onClick={() => copyText("8028 NW 14TH ST")}>
                      8028 NW 14TH ST
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-end" xs="6"> <b>Zipcode:  </b> </Col>
                  <Col xs="6">
                    <UncontrolledTooltip
                      placement="right"
                      target={`zip-${componentId}`}
                    >
                      Copiar
                    </UncontrolledTooltip>
                    <Button className={styles.addressCopyButton} id={`zip-${componentId}`} color="light" onClick={() => copyText("33126-1612")}>
                      33126-1612
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-end" xs="6"> <b>State: </b> </Col>
                  <Col xs="6">
                    <UncontrolledTooltip
                      placement="right"
                      target={`state-${componentId}`}
                    >
                      Copiar
                    </UncontrolledTooltip>
                    <Button className={styles.addressCopyButton} id={`state-${componentId}`} color="light" onClick={() => copyText("Florida (FL)")}>
                      Florida (FL)
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-end" xs="6"> <b>Ciudad: </b> </Col>
                  <Col xs="6">
                    <UncontrolledTooltip
                      placement="right"
                      target={`city-${componentId}`}
                    >
                      Copiar
                    </UncontrolledTooltip>
                    <Button className={styles.addressCopyButton} id={`city-${componentId}`} color="light" onClick={() => copyText("Miami")}>
                      Miami
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-end" xs="6"> <b>Phone: </b></Col>
                  <Col xs="6">
                    <UncontrolledTooltip
                      placement="right"
                      target={`phone-${componentId}`}
                    >
                      Copiar
                    </UncontrolledTooltip>
                    <Button className={styles.addressCopyButton} id={`phone-${componentId}`} color="light" onClick={() => copyText("786-423-0001")}>
                      786-423-0001
                    </Button>
                  </Col>
                </Row>

              </LoadingPlaceholder>
            )}
          </CardText>
        </CardBody>
      </Card >
      {props.children}
    </div >
  );
}

export default UserPOBoxDetails;